// extracted by mini-css-extract-plugin
module.exports = {"tabs":"People_tabs__3ZQpV","tab":"People_tab__3Px4u","active":"People_active__2DOGh","main":"People_main__SO5IZ"};